import axios from 'axios';
import * as qs from 'query-string';

export const axiosDefaults = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'client-name': 'login',
  },
  paramsSerializer: (params: any) => qs.stringify(params),
};

const axiosInstance = axios.create(axiosDefaults);

export default axiosInstance;
